import { useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { CSVLink } from "react-csv";
import DataTable from "react-data-table-component";
import LoadingOverlay from "react-loading-overlay";
import { ThreeDot } from "../../../assets/images";
import moment from "moment";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";
import { useHistory } from "react-router-dom";

export default function VIPUserList() {
  const history = useHistory();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [pagination, setPagination] = useState({
    limit: limit,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [vipMembers, setVipMembers] = useState([]);
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    getVipMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const getVipMembers = () => {
    setLoading(true);

    axios
      .get(
        `/vip-members-list?page=${page}&limit=${limit}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setVipMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong");
      });
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "300px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "350px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "200px",
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
      width: "150px",
    },

    {
      name: "Created At",
      selector: (row) => moment(row.createdAt).format("MM-DD-YYYY"),
      sortable: true,
      width: "150px",
    },

    {
      name: "Password",
      selector: (row) => (
        <div>
          {passwordShowHide === row.id ? (
            <>
              <span>{row.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row.id);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {/* <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                setResetPassword(true);
                // setUser_id(row.id);
              }}
            >
              Reset Password
            </div> */}
            <div
              className={`dropdown-item ${row.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row.id);
              }}
            >
              Active
            </div>
            <div
              className={`dropdown-item ${!row.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row.id);
              }}
            >
              Inactive
            </div>

            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                history.push(`/vip-member-transaction-history/${row._id}`);
              }}
            >
              Transaction History
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const activeInactiveUser = (id) => {
    setLoading(true);

    axios
      .post("/active-inactive-tviuser", { id }, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          getVipMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(`/csp-vip-members-list?search=${search}`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((allData) => ({
            id: allData.id,
            name: allData.name,
            email: allData.email,
            phone: allData.phone ? allData.phone : "N/A",
            planName: allData.packageDetails.packageName,
            planPrice: allData.packageDetails.packagePrice
              ? "$" + allData.packageDetails.packagePrice
              : "N/A",
            planExpire: allData.packageDetails.expireDate
              ? allData.packageDetails.expireDate
              : "N/A",
            planStatus: allData.isSubscriptionCanceled ? "Canceled" : "Active",
            loginDate: "",
            source: allData.isVilocityUser ? "Vilocity" : "TVI",
            arriviaUserId: allData.arriviaUserId
              ? allData.arriviaUserId
              : "N/A",
            paypalId: allData.paypalId ? allData.paypalId : "N/A",
            directDiposit:
              allData.commissionType === "Direct Deposit" ? "Yes" : "No",
            createdAt: moment(allData.createdAt).format("MM-DD-YYYY"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Id", key: "id" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "phone" },
    { label: "Plan Name", key: "planName" },
    { label: "Plan Price", key: "planPrice" },
    { label: "Plan Expire", key: "planExpire" },
    { label: "Plan Status", key: "planStatus" },
    { label: "Login Date", key: "loginDate" },
    { label: "Source", key: "source" },
    { label: "Arrivia User Id", key: "arriviaUserId" },
    { label: "Paypal Id", key: "paypalId" },
    { label: "Direct Diposit", key: "directDiposit" },
    { label: "Created At", key: "createdAt" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>VIP Users List</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={
                        "TVI-vip-member-list-" +
                        moment().format("DDMMYYYY-HHmmss") +
                        ".csv"
                      }
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={vipMembers}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={vipMembers.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
